import { yellow } from 'bold-ui/lib/styles/colors'
import { SessaoQuery, TipoAtendimentoProfissional } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { SoapSection } from '../SoapSection'
import { AvaliacaoForm, AvaliacaoFormModel } from './AvaliacaoForm'

export interface AvaliacaoSectionProps {
  name: MetaPath<AvaliacaoFormModel>
  acessoProfissional: SessaoQuery['sessao']['acesso']
  cidadao: CidadaoAtendimento
  tipoAtendProf: TipoAtendimentoProfissional
  prontuarioId: ID
  dataAtendimento: Instant
}

export function AvaliacaoSection(props: AvaliacaoSectionProps) {
  const { name, cidadao, acessoProfissional, tipoAtendProf, prontuarioId, dataAtendimento } = props
  return (
    <SoapSection initial='A' title='Avaliação' color={yellow}>
      <AvaliacaoForm
        name={name}
        cidadao={cidadao}
        acessoProfissional={acessoProfissional}
        tipoAtendProf={tipoAtendProf}
        prontuarioId={prontuarioId}
        dataAtendimento={dataAtendimento}
      />
    </SoapSection>
  )
}
